import { render, staticRenderFns } from "./RouteModelView.vue?vue&type=template&id=4c9c5a26"
import script from "./RouteModelView.vue?vue&type=script&lang=js"
export * from "./RouteModelView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports